import { Pickaxe, Sparkles } from "lucide-react";


export const MiningArena = ({ striking, lastReward }) => (
  <div className={`mining-arena ${striking ? "is-striking" : ""}`} data-testid="mining-strike-arena">
    <img src="/game/mining-scene.jpeg" alt="Miner working beside two mine wagons" className="mining-scene" />
    <div className="mining-vignette" aria-hidden="true" />
    <div className="ore-target" aria-hidden="true"><Sparkles size={18} /></div>
    <div className="animated-pickaxe" aria-hidden="true"><Pickaxe size={42} /></div>
    {lastReward && (
      <div className="mining-reward-pop" key={lastReward.key} aria-live="polite" data-testid="mining-last-reward">
        +${lastReward.value.toFixed(3)}
      </div>
    )}
  </div>
);
